/**
 * WebApi
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type TenderPriceRatingMethods = 'LinearWithBandwidth' | 'Exponential' | 'LinearReverse' | 'Linear';

export const TenderPriceRatingMethods = {
    LinearWithBandwidth: 'LinearWithBandwidth' as TenderPriceRatingMethods,
    Exponential: 'Exponential' as TenderPriceRatingMethods,
    LinearReverse: 'LinearReverse' as TenderPriceRatingMethods,
    Linear: 'Linear' as TenderPriceRatingMethods
};

